import { Drawer } from 'clad-ui';
import type { DrawerProps } from 'clad-ui/patterns/Drawer/Drawer';
import React from 'react';
import Image from 'next/image';
import { containerCss, descriptionCss, titleCss } from './index.style';
import { POPUP_ICON_URL } from '~/constants';

type MessageDialogProps = Omit<DrawerProps, 'children'> & {
  status?: 'error' | 'success' | 'warning';
  contentTitle: string;
  contentDescription: string;
  title?: string;
  children?: React.ReactNode;
  isHtmlDescription?: boolean;
};

const MessageDialog = (props: MessageDialogProps) => {
  const {
    title = 'Thông báo',
    status = 'success',
    contentTitle,
    contentDescription,
    isHtmlDescription,
    ...rest
  } = props;

  const iconSrc = POPUP_ICON_URL[status];

  return (
    <Drawer {...rest} title={title}>
      <div className={containerCss}>
        <Image width={80} height={80} src={iconSrc} alt={status} />
        <p className={titleCss}>{contentTitle}</p>
        {isHtmlDescription ? (
          <div
            className={descriptionCss}
            dangerouslySetInnerHTML={{ __html: contentDescription }}
          />
        ) : (
          <p className={descriptionCss}>{contentDescription}</p>
        )}
      </div>
    </Drawer>
  );
};

export default MessageDialog;
